import { SVGProps } from "react";

const NotificationIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15.9257 13.8895C14.7287 12.8777 14.0423 11.3989 14.0423 9.83217V7.625C14.0423 4.83913 11.9729 2.533 9.29232 2.14667V1.29167C9.29232 0.853875 8.93765 0.5 8.50065 0.5C8.06365 0.5 7.70898 0.853875 7.70898 1.29167V2.14667C5.02761 2.533 2.95898 4.83913 2.95898 7.625V9.83217C2.95898 11.3989 2.27261 12.8777 1.06848 13.8958C0.760526 14.1594 0.583984 14.5426 0.583984 14.9479C0.583984 15.7119 1.20544 16.3333 1.9694 16.3333H15.0319C15.7959 16.3333 16.4173 15.7119 16.4173 14.9479C16.4173 14.5426 16.2408 14.1594 15.9257 13.8895Z" />
      <path d="M8.50038 19.5C9.93409 19.5 11.1335 18.478 11.409 17.125H5.5918C5.8673 18.478 7.06667 19.5 8.50038 19.5Z" />
    </svg>
  );
};

export default NotificationIcon;
